import React from "react";
import { Link, withPrefix } from "gatsby";
import cleanCompanyName from "../../utilities/cleanCompanyName";
//import { useDiscussion } from "./DiscussionContext";

const DiscussionEntityLink = ({ entity, className = undefined, inNewWindow = false, children }) => {
  
  //const { encodedFilters } = useDiscussion();

  const entityPath = `/discussion/stakeholders/${entity.slug}/`;

  return (
    <>
      {inNewWindow ? (
        <a 
          href={withPrefix(entityPath)} 
          title={cleanCompanyName(entity.name)}
          target={inNewWindow ? "_blank" : undefined}
          rel="noopener noreferrer"
          className={className}
        >{children ? children : cleanCompanyName(entity.name)}</a>
      ) : (
        <Link 
          to={entityPath} 
          title={cleanCompanyName(entity.name)}
          className={className}
        >{children ? children : cleanCompanyName(entity.name)}</Link>
      )}
    </>
  );
};

export default DiscussionEntityLink;